import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import mixin from "react-mixin";

import { FormAPI, FlashMessageAPI } from 'lecom-api';

import { connectToStore } from '../../reflux/decorators/connect_to_store';

import { SearcherActions, SearcherStore } from "../reflux/searcher_store";
import SearcherTypes from "../../searcher/searcher_types";
import ScreenSizes from '../../screen_sizes';

import { FormEvents, FormElements, FormEventHandler } from '../../form/events/form_event_handler';

import Input from 'form/components/input/input';

import Modal from 'realize_overrides/components/modal/modal.jsx';
import Grid from 'realize_overrides/components/grid/grid';

import TableCellRenderFactory from 'grid/table_cell_render_factory';

import FlashMessages from '../../flash_message/components/flash_messages.jsx';

import { ModalActions, ModalStore } from '../../realize_overrides/stores/modal_store.js';

const Realize = {
	Modal: Modal,
	Grid: Grid,
	ContainerMixin: window.ContainerMixin,
	ModalHeader: window.ModalHeader,
	ModalContent: window.ModalContent,
	ModalFooter: window.ModalFooter,
	Utils: window.UtilsMixin
};

@connectToStore(SearcherStore)
@mixin.decorate(Realize.ContainerMixin)
export default class SearcherModal extends React.Component {

	static propTypes = {
		headerTitle: PropTypes.string,
		buttonName: PropTypes.string,
		selectionEmptyMessage: PropTypes.string,
		modal: PropTypes.object,
		closeButton: PropTypes.object,
		filterValues: PropTypes.object,
		results: PropTypes.array,
		page: PropTypes.object,
		searcher: PropTypes.object,
		isLoading: PropTypes.bool,
		lookupType: PropTypes.string
	};

	static defaultProps = {
		headerTitle: 'Lupa',
		buttonName: 'Enviar',
		selectionEmptyMessage: 'Não é possível preencher o formulário sem dados selecionados na tabela.',
		modal: {},
		closeButton: {
			name: 'Fechar',
			style: 'cancel',
			icon: 'clear'
		},
		filterValues: {},
		results: [],
		page: {},
		searcher: {},
		isLoading: false,
		lookupType: ''
	};

	constructor(props) {
		super(props);

		this.onOpenModal = this.onOpenModal.bind(this);
		this.dismissModal = this.dismissModal.bind(this);
		this.clearFilterValues = this.clearFilterValues.bind(this);
	}

	setModalContentHeight(modalComponent, defaultResizer) {
		let modalRef = modalComponent.refs.modal;
		if(window.innerWidth > ScreenSizes.SMALL_SCREEN_WIDTH) {
			defaultResizer();
		}
		else {
			let $modalNode = $(ReactDOM.findDOMNode(modalRef));
			let height = window.innerHeight - 16;

			$modalNode.css('max-height', height);
			$modalNode.css('height', height);
		}
	}

	componentDidUpdate(){
		if($('.clickable-row').is(':visible') === true){
			$('.clickable-row')[0].setAttribute('tabindex', '0');
		}

		this.tabGridSearcher();
	}

	perPageGrid(){
		let idDivModalIsVisible = $(`#${this.props.searcher.id}-modal`).is(':visible');
		if(idDivModalIsVisible === true){
			let isVisibleRow = $('.clickable-row').is(':visible');
			if(isVisibleRow === true){
				let rows = $('.clickable-row');
				setTimeout(() => { rows[0].focus() }, 500);
			}
		}
	}

	tabGridSearcher(){
		let isVisibleRow = $('.clickable-row').is(':visible');

		if(isVisibleRow === true){
			let rows = $('.clickable-row');
			rows.attr('tabindex', '0');

			rows.keyup((e) => {
				if(e.which === 13)
					e.currentTarget.click();
			})

			this.perPageGrid();
		}
	}

	tabOrder(){
		let idDivModal = `${this.props.searcher.id}-modal`;
		let searcherFields = this.props.searcher.mappings.filter(s => s.searchable === true);

		$('.buttons-lookup-modal .form__button-group .button-cancel').attr('tabindex' , '0');

		$('.btn-cancel-modal-searcher').attr('tabindex', '0');
		$('.btn-cancel-modal-searcher').off('keydown');
		$('.btn-cancel-modal-searcher').keypress(function(e) {
			if(e.which === 13)
				$('.btn-cancel-modal-searcher')[0].click()
		});

		$('.modalLupa').off('keydown');
		$('.modalLupa').keydown((e) => {
			if (e.which === 27 && !$(e.target.parentElement).hasClass("input-autocomplete__search")) {
				$('.btn-cancel-modal-searcher')[0].click();
			}
		});

		if(searcherFields.length > 0){
			let nameField = searcherFields[0].column.name;
			let idField = `${nameField}__lookup-modal`;

			// $(`#${idField}`)[0].focus();

			$(`#${idField}`).keydown((e) => {
				if(e.shiftKey && e.keyCode === 9)
					return false
			});

			$('.btn-cancel-modal-searcher').keydown((e) => {
				if(e.shiftKey){
					return true
				}

				if(e.which === 9 || e.keyCode === 9 ){
					// $(`#${idField}`)[0].focus();
					$(`#${idDivModal} .modal-header span`).focus();
					return false
				}
			});
		}

		if(searcherFields.length === 0) {
			// $(`#${idDivModal} .form__button-group button `)[1].focus();

			$(`#${idDivModal} .form__button-group .button-cancel`).keydown((e) => {
				if(e.shiftKey && e.keyCode === 9)
					return false
			})

			$('.btn-cancel-modal-searcher').keydown((e) => {
				if(e.shiftKey){
					return true
				}

				if(e.which === 9 || e.keyCode === 9 ){
					// $('.buttons-lookup-modal .form__button-group .button-cancel')[0].focus();
					$(`#${idDivModal} .modal-header span`).focus();
					return false
				}
			});
		}
	}

	focusButtonSearcher(){
		let idField = this.props.searcher.id;
		$(`#${idField}`)[0].focus();
	}

	// Modal lifecycle functions

	onOpenModal() {
		let searcher = this.props.searcher;
		let isLookup = searcher.searcherType === SearcherTypes.LOOKUP;

		this.tabOrder();

		if (isLookup && searcher.searchOnLoad)
			SearcherActions.search(this.props.uniqueStoreItemId, this.props.searcher);
	}

	dismissModal() {
		let modal = this.modalRef;

		this.focusButtonSearcher();

		let idDivModal = `${this.props.searcher.id}-modal`;
		$(`#${idDivModal} .form__button-group button `).off('keydown');
		$(".btn-cancel-modal-searcher").off('keydown');

		ModalActions.close({
			modalId: modal.props.id
		});
	}

	validateTypeSearch() {
		if(this.props.lookupType && this.props.lookupType === 'api')
			return false

		return true
	}

	// Grid handling functions

	getSearcherGridProps() {
		const { searcher, results, page, isLoading } = this.props;
		return {
			emptyMessage: 'table.emptyResultSearcher',
			contextType: 'SEARCHER',
			isLoading,
			pagination: this.validateTypeSearch(),
			clientSide: true,
			handleClientSidePagination: false,
			selectable: 'none',
			page: (page.number + 1) || 1,
			paginationConfigs: {
				window: 2,
			},
			actionButtons: {
				collection: [],
				member: [],
			},
			data: {
				dataRows: results,
				count: (page.totalElements || results.length),
			},
			columns: this.parseMappingColumns(searcher.mappings),
			filter: {
				collapsible: false,
				inputs: this.parseMappingFilters(searcher.mappings),
				onReset: this.clearFilterValues,
				className: 'buttons-lookup-modal',
				inputWrapperComponent: Input,
			},
			onFilterSubmit: this.handleGridFilterSubmit.bind(this),
			onClickRow: this.handleRowClick.bind(this),
			onPagination: this.handleGridPagination.bind(this),
			ref: (ref) => { this.gridRef = ref; },
		};
	}

	clearFilterValues() {
		FlashMessageAPI.flash('flash-search-modal').clear();
		SearcherActions.setProperties(this.props.uniqueStoreItemId, { filterValues: {} });
		SearcherActions.reset(this.props.uniqueStoreItemId);
	}

	parseMappingColumns(searcherMappings) {
		var returnSearcherMapping = { };
		searcherMappings.forEach((searcherMapping) => {
			if (searcherMapping.visible) {
				Object.assign(returnSearcherMapping, {  [this.getColumnFieldName(searcherMapping)]: this.parseColumnGridProps(searcherMapping) });
			}
		});
		return returnSearcherMapping;
	}

	getColumnFieldName(searcherMapping) {
		return searcherMapping.dataStoreGridColumn || searcherMapping.dataStoreColumn;
	}

	parseColumnGridProps({ formField, column }) {
		const { searcher } = this.props;
		const { id, gridFormParent } = formField;
		const fieldAPI = this.getFieldAPI(searcher.formId, id, gridFormParent);
		const columnProps = Object.assign({}, column, { component: TableCellRenderFactory });

		columnProps.idField = columnProps.name;
		delete columnProps.name;

		return { ...columnProps, visible: fieldAPI.visible() };
	}

	parseMappingFilters(searcherMappings) {
		var objSearcher = { };
		searcherMappings.forEach(searcherMapping => {
			if (!!searcherMapping.searchable) {
				let fieldName = searcherMapping.formField.name;
				objSearcher[fieldName] = this.parseFilterInputProps(searcherMapping);
			}
		});
		return objSearcher;
	}

	getFieldAPI(formId, id, gridFormParent) {
		const formAPI = FormAPI.form(formId);

		return (gridFormParent)
			? formAPI.fields(gridFormParent).fields(id)
			: formAPI.fields(id);
	}

	parseFilterInputProps(searcherMapping) {
		let filterInputProps = Object.assign({}, searcherMapping.formField);
		let originalId = filterInputProps.id;
		let gridFormParent = filterInputProps.gridFormParent;
		const { searcher } = this.props;
		const fieldAPI = this.getFieldAPI(searcher.formId, originalId, gridFormParent);

		filterInputProps.value = this.props.filterValues[filterInputProps.name];
		// filterInputProps.name = filterInputProps.id = `${filterInputProps.name}__lookup-modal`;
		filterInputProps.id = `${filterInputProps.name}__lookup-modal`;
		filterInputProps.defaultValue = "";

		if (filterInputProps.component === 'autocomplete' && this.hasOptionsUrlList(fieldAPI, filterInputProps)) {
			const fieldOptions = fieldAPI ? fieldAPI.options() : undefined;

			if (fieldOptions) {

				filterInputProps.options = fieldOptions;
			}
		}

		delete filterInputProps.className
		delete filterInputProps.type
		delete filterInputProps.disabled
		delete filterInputProps.visible
		delete filterInputProps.readOnly
		return filterInputProps;
	}

	hasOptionsUrlList(fieldAPI, filterInputProps) {
		return filterInputProps.optionsUrl !== undefined || fieldAPI.actions().find(action => action.searchOnLoad());
	}

	handleRowClick(event, dataRow) {
		const { searcher, uniqueStoreItemId } = this.props;
		const formAPI = FormAPI.form(searcher.formId);
		const fieldAPI = formAPI.allFields().find(f => f.id === searcher.formFieldName);

		this.dismissModal();
		SearcherActions.updateFormValues(uniqueStoreItemId, { resources: dataRow }, searcher);
		FormEventHandler.publish(FormEvents.SEARCHER_SELECT, FormElements.ACTION, this.getSearcherActionName());
		fieldAPI.publish(FormEvents.SEARCHER_SELECT, { resources: dataRow });
	}

	handleGridFilterSubmit(event, postData) {
		event.preventDefault();

		setTimeout(() => {
			let idModal = this.props.modal.id;
			$(`#${idModal} .table-wrapper tbody tr`).attr('tabindex', 0);
		}, 1000);

		SearcherActions.search(this.props.uniqueStoreItemId, this.parseFilterPostData(postData));
	}

	handleGridPagination({ page, perPage }) {
		SearcherActions.paginate(this.props.uniqueStoreItemId, page - 1, perPage);
	}

	parseFilterPostData(postData) {
		return Object.keys(postData)
			.filter((k) => k !== '_method')
			.reduce((acc, k) => Object.assign(acc, { [k.replace(/__lookup-modal$/, '')]: postData[k] }), {});
	}

	getSearcherActionName() {
		let searcherActionObj = this.props.searcher;
		return searcherActionObj.id || searcherActionObj.name;
	}

	// Render functions

	renderHeader() {
		return (
			<Realize.ModalHeader key="modal-header">
				<span className="h5-custom" tabIndex="0">{this.props.headerTitle}</span>
			</Realize.ModalHeader>
		);
	}

	renderContent() {
		return (
			<Realize.ModalContent>
				<FlashMessages id="flash-search-modal"/>
				<Realize.Grid {...this.getSearcherGridProps()} />
			</Realize.ModalContent>
		);
	}

	renderFooter() {
		return (
			<Realize.ModalFooter className={'right-align'}>
				<Button {...this.props.closeButton}
					element="a"
					role='button'
					onClick={this.dismissModal}
					className='btn-cancel-modal-searcher'
				/>
			</Realize.ModalFooter>
		);
	}

	render() {
		if (!this.props.searcher.id)
			return <span />;

		return (
			<Realize.Modal dismissible={false}
				className='modalLupa'
				{...this.props.modal}
				minContentHeight={600}
				resizer={this.setModalContentHeight}
				ready={this.onOpenModal}
				ref={(ref) => { this.modalRef = ref; }}
				isMobile={this.props.isMobile}>
					{this.renderHeader()}
					{this.renderContent()}
					{this.renderFooter()}
			</Realize.Modal>
		);
	}
}
